<template>
  <div class="modal fade" tabindex="-1" role="dialog" ref="modal">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span
              aria-hidden="true">&times;</span></button>
          <h3 class="m-top-0">
            <slot name="header">
              Default header
            </slot>
          </h3>
        </div>
        <div class="modal-body" ref="body">
          <slot></slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    openRemote(url) {
      this.$http.get(url).then(function (response) {
        this.$refs.body.innerHTML = response.data;
        this.open();
      });
    },

    open() {
      jQuery(this.$refs.modal).modal();
    },

    close() {
      jQuery(this.$refs.modal).modal('hide');
    },
  }
}
</script>



// WEBPACK FOOTER //
// resources/js/components/Modal.vue